import "core-js/modules/es.array.concat";
import "core-js/modules/es.object.to-string";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import uploadImagetow from '@/components/uploadImagetow';
import { bagItemTypeList } from "@/api/dataAll/dataAll";
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
export default {
  name: "propertyType",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  components: {
    uploadImagetow: uploadImagetow
  },
  data: function data() {
    return {
      PrimitiveData: [],
      upData: {}
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.upData.game_id = _this.rawData.game_id;
              _this.paramsData.game_id = _this.rawData.game_id;

              _this.getList();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList() {
      var _this2 = this;

      this.reqLoading = true;
      bagItemTypeList(this.paramsData).then(function (res) {
        if (res.status == 200) {
          _this2.currentPage = 1;
          _this2.PrimitiveData = res.data;
          _this2.tableCopyTableList = JSON.parse(JSON.stringify(res.data));
          _this2.tableData = _this2.currentChangePage(_this2.pageSize, _this2.currentPage);
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('idLabel'),
        prop: 'type_id'
      }, {
        label: this.$t('nameLabel'),
        prop: 'type_name'
      }];
      var data = [{
        type_id: 'type_id',
        type_name: 'type_name'
      }].concat(_toConsumableArray(this.PrimitiveData));
      this.$export.csv({
        columns: columns,
        data: data,
        noHeader: true,
        title: this.$route.meta.title
      });
    },
    Refresh: function Refresh() {
      this.list = [];
      this.getList(1);
    }
  }
};